import { render } from "./SubKelompokAccount.vue?vue&type=template&id=780b4012&scoped=true"
import script from "./SubKelompokAccount.vue?vue&type=script&lang=js"
export * from "./SubKelompokAccount.vue?vue&type=script&lang=js"

import "./SubKelompokAccount.vue?vue&type=style&index=0&id=780b4012&scoped=true&lang=css"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780b4012"]])

export default __exports__